export default __webpack_public_path__ + "static/media/checkSmallWhite.7a4a6306.svg";